import { EditOutlined } from '@ant-design/icons'
import { Button, Form, Input, Select, Tag, Tooltip } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { LimiterTable } from 'components/LimiterTable/LimiterTable'
import ServerTable from 'components/ServerTable/ServerTable'
import ServerTableFilters from 'components/ServerTable/ServerTableFilters'
import SettingsCard from 'egi/app/Settings/components/SettignsCard/SettingsCard'
import { useTables } from 'hooks'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { partnerApiEdit } from 'routes/routes'
import { partnersStatusColor } from 'styles/colors'
import mask from 'utils/masks'
import { tablesResetFiltersValues, tablesSetFiltersValues, tablesUpdate } from 'store/modules/tables/actions'
import { IPartnerListItem, partnerServices, partnerTags } from './partnerApiCredentials'

const LIMIT = 10

const tagColors: { [label: string]: string | undefined } = {
  Desabilitado: partnersStatusColor.starting,
  Habilitado: partnersStatusColor.approved,
  Bloqueado: partnersStatusColor.blocked,
  'Sem token': partnersStatusColor.pendencies,
  Cancelado: partnersStatusColor.canceled
}

export default function PartnerApiList () {
  const [ready, setReady] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const table = useTables()

  useEffect(() => {
    dispatch(tablesSetFiltersValues({ page: 1, limit: LIMIT }))
    setReady(true)

    return () => {
      dispatch(tablesResetFiltersValues(false))
    }
  }, [dispatch])

  const editPath = (promoterId: string) => `/auth${partnerApiEdit.path.replace(':promoterId', promoterId)}`

  const columns: ColumnsType<IPartnerListItem> = [
    {
      title: 'Nome',
      dataIndex: 'name',
      align: 'center',
      width: 220,
      render: (name: string, row) => <Link className="link-style color-tertiary font-500" to={editPath(row._id)}>{name}</Link>
    },
    { title: 'E-mail', dataIndex: 'email', width: 220 },
    { title: 'CNPJ', dataIndex: 'cnpj', width: 160, render: (cnpj?: string) => cnpj ? mask(cnpj, 'cnpj') : '-' },
    {
      title: 'Parceiro de API',
      key: 'partner',
      width: 300,
      render: (_, row) => partnerTags(row).map(label => (
        <Tag key={label} color={tagColors[label]}>{label}</Tag>
      ))
    },
    {
      title: 'Serviços',
      key: 'servicesCount',
      width: 100,
      render: (_, row) => `${row.servicesCount} de ${partnerServices.length}`
    },
    {
      title: 'Ações',
      key: 'actions',
      align: 'center',
      width: 80,
      render: (_, row) => (
        <Tooltip title="Editar">
          <Button type="link" onClick={() => history.push(editPath(row._id))}>
            <EditOutlined />
          </Button>
        </Tooltip>
      )
    }
  ]

  return (
    <>
      <SettingsCard.Header
        title="Credenciais de API de parceiros"
        description="Selecione um promotor para habilitar a integração, gerar o token de acesso e configurar serviços e callbacks. Visível somente para o usuário AGX."
      />

      <SettingsCard>
        <SettingsCard.title>Promotores</SettingsCard.title>
        <SettingsCard.description className="mb-3">
          Busque o promotor pelo nome, e-mail ou CNPJ e clique em editar
        </SettingsCard.description>

        <LimiterTable>
          <Form layout="vertical">
            <ServerTableFilters>
              <Form.Item label="Buscar" style={{ width: 380, maxWidth: '100%' }}>
                <Input.Search
                  className="table-filter"
                  allowClear
                  placeholder="Nome, e-mail ou CNPJ"
                  onSearch={(search) => dispatch(tablesSetFiltersValues({ ...table.filters, search: search.trim(), page: 1 }))}
                />
              </Form.Item>

              <Form.Item label="Parceiro de API">
                <Select
                  value={table.filters.partner ?? ''}
                  onChange={(partner) => dispatch(tablesSetFiltersValues({ ...table.filters, partner, page: 1 }))}
                  options={[
                    { label: 'Todos', value: '' },
                    { label: 'Habilitado', value: 'true' },
                    { label: 'Desabilitado', value: 'false' }
                  ]}
                />
              </Form.Item>

              <Button type="primary" onClick={() => dispatch(tablesUpdate())}>Atualizar</Button>
            </ServerTableFilters>
          </Form>

          {ready && <ServerTable url="/partner-api/promoters" columns={columns} />}
        </LimiterTable>
      </SettingsCard>
    </>
  )
}
